module.exports = __webpack_public_path__ + "static/fonts/DINPro-Black.9b609f6.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/DINPro-Black.otf
// module id = 9JrE
// module chunks = 1